import { PropsWithChildren } from 'react';
import { Modal, ModalProps } from 'react-bootstrap';

interface CustomModalProps extends ModalProps {
    disableAutoStacking?: boolean;
}

const CustomModal = (props: PropsWithChildren<CustomModalProps>) => {
    const {
        onShow,
        onHide,
        children,
        disableAutoStacking = false,
        ...otherProps
    } = props;

    const handleModalShow = () => {
        typeof onShow === "function" && onShow();
        if (disableAutoStacking) return;

        const modals = document.querySelectorAll<HTMLElement>('.modal.show');
        const zIndex = 1040 + 10 * modals.length;

        modals.forEach((modal) => {
            modal.style.zIndex = `${zIndex}`;
        });

        const backdrop = document.querySelector<HTMLElement>('.modal-backdrop');
        if (backdrop) {
            backdrop.style.zIndex = `${zIndex - 1}`;
            backdrop.classList.add('modal-stack');
        }
    };

    const handleModalHide = () => {
        typeof onHide === "function" && onHide();
        if (disableAutoStacking) return;

        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
            backdrop.classList.remove('modal-stack');
        }
    };


    return (
        <Modal
            onShow={handleModalShow}
            onHide={handleModalHide}
            {...otherProps}
        >
            { children }
        </Modal>
    );
};

export default CustomModal;
